import { render, staticRenderFns } from "./InvD_DeliveryItemsSummary.vue?vue&type=template&id=7b1e120f"
import script from "./InvD_DeliveryItemsSummary.vue?vue&type=script&lang=js"
export * from "./InvD_DeliveryItemsSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports